import { ZuiBaseElement } from '@zywave/zui-base';
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { style } from './zui-spinner-css.js';

/**
 * Lightweight spinner graphic to indicate loading.
 *
 * @element zui-spinner
 *
 * @cssprop [--zui-spinner-color=var(--zui-gray)] - Spinner circle color
 * @cssprop [--zui-spinner-size=1.75rem (28px)] - To customize size of spinner assign a new value to this custom property; this property applies to both width & height therefore component assumes spinner is square aspect ratio
 * @cssprop [--zui-spinner-stroke-width=3px] - Thickness of the circle

 */

export class ZuiSpinnerElement extends ZuiBaseElement {
  /**
   * Set to true to show spinner
   */
  @property({ type: Boolean, reflect: true })
  active = false;

  /**
   * Alt text for better accessibility while spinner is present
   */
  @property({ type: String, reflect: true })
  alt = 'active';

  static get styles() {
    return [super.styles, style];
  }

  connectedCallback() {
    super.connectedCallback();
    this.setAttribute('aria-label', this.alt);
  }

  render() {
    // !formatting of html below looks gross, specifically within ".spinner-layer", but is necessary, the spinner becomes misshaped when whitespace is added due to "white-space: nowrap" style on ".spinner-layer"
    return html`
      <div class="container">
        <div class="spinner-layer">
          <div class="circle-clipper left"><div class="circle"></div></div
          ><div class="circle-clipper right"><div class="circle"></div></div>
        </div>
      </div>
    `;
  }
}

customElements.define('zui-spinner', ZuiSpinnerElement);
